import axios from "axios";
import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button } from "components";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

const JobCardProductionRejectionDetailListAdd = () => {
  const [workOrder, setWorkOrder] = useState([]);
  const [jobCardPendingList, setJobCardPendingList] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [isForJobWork, setIsForJobWork] = useState(true);
  const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
  const [selectedReturnWarehouse, setSelectedReturnWarehouse] = useState(null);
  const [selectedReworkWarehouse, setSelectedReworkWarehouse] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(true);

  let navigate = useNavigate();
  const token = sessionStorage.getItem("token");
  const headers = { headers: { Authorization: `Bearer ${token}` } };

  // ✅ Fetch Work Orders
  const workOrderGet = () => {
    axios
      .post(
        "/api/purple-fusion/jobcardproductionrejectiondetail/get/pending/workorder",
        { is_for_job_work: isForJobWork },
        headers
      )
      .then((res) => {
        setWorkOrder(res.data);
        console.log(res.data);
      })
      .catch(console.error);
  };

  // ✅ Fetch Pending Job Cards for selected Work Order
  const pendingJobWorkListGet = (workOrderId) => {
    axios
      .post(
        "/api/purple-fusion/jobcardproductionrejectiondetail/get/pending/items",
        { work_order_id: workOrderId },
        headers
      )
      .then((res) => {
        console.log(res.data);
        setJobCardPendingList(res.data);
      })
      .catch(console.error);
  };

  // ✅ Fetch Warehouses
  const fetchWarehouses = () => {
    axios
      .post("/api/purple-fusion/companywarehouse/get", {}, headers)
      .then((res) => {
        console.log(res.data);
        setWarehouses(res.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  // ✅ Run on mount & when work type changes
  useEffect(() => {
    workOrderGet();
    fetchWarehouses();

    // Reset return warehouse when not job work
    if (!isForJobWork) {
      setSelectedReturnWarehouse(null);
    }
  }, [isForJobWork]);

  // ✅ Handle Form Submit
  const handleSubmit = (values) => {
    let hasReturnQty = false;
    let hasReworkQty = false;

    const payload = [];

    jobCardPendingList.forEach((item) => {
      const id = item.job_card_production_id;
      if (selectedItems.includes(id)) {
        const { returnQty, reworkQty, scrapQty, remarks } = values[id] || {};
        const item_detail_id = item.item_detail_id;

        if (Number(returnQty) > 0) hasReturnQty = true;
        if (Number(reworkQty) > 0) hasReworkQty = true;

        // ✅ Return only for Job Work
        if (isForJobWork && Number(returnQty) > 0)
          payload.push({
            job_card_production_id: id,
            job_card_rejection_type_id: 3, // Return
            quantity: Number(returnQty),
            remarks: remarks || "",
            item_detail_id,
            company_warehouse_id: selectedReturnWarehouse,
          });

        // ✅ Always allow Rework
        if (Number(reworkQty) > 0)
          payload.push({
            job_card_production_id: id,
            job_card_rejection_type_id: 2, // Rework
            quantity: Number(reworkQty),
            remarks: remarks || "",
            item_detail_id,
            company_warehouse_id: selectedReworkWarehouse,
          });
      }
    });

    // Validation checks
    if (payload.length === 0) {
      toast.error("Please select at least one item and enter quantity!");
      return;
    }

    if (isForJobWork && hasReturnQty && !selectedReturnWarehouse) {
      toast.error("Please select a Return Warehouse for Return Quantity!");
      return;
    }

    if (hasReworkQty && !selectedReworkWarehouse) {
      toast.error("Please select a Rework Warehouse for Rework Quantity!");
      return;
    }

    console.log("📦 Final Payload:", payload);

    axios
      .post(
        "/api/purple-fusion/jobcardproductionrejectiondetail/create",
        payload,
        headers
      )
      .then((response) => {
        console.log(response.data);
        const message = response.data.message;

        response.data.status
          ? toast.success(message, {
              autoClose: 2000,
              onClose: () => {
                setIsModalOpen(false);
                navigate(`/JobCardProductionRejectionDetailList`);
              },
            })
          : toast.error(message, {
              autoClose: 2000,
            });
      })
      .catch((error) => {
        console.log(error);
        setIsModalOpen(false);
        navigate("*");
      });
  };

  // ✅ Selection Handlers
  const toggleItemSelection = (id) => {
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const toggleSelectAll = () => {
    setSelectedItems(
      selectedItems.length === jobCardPendingList.length
        ? []
        : jobCardPendingList.map((x) => x.job_card_production_id)
    );
  };

  const customStyle = {
    content: {
      width: "85%",
      hieght: "80%",
      margin: "auto",
    },
    overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
  };

  return (
    // <Modal
    //   isOpen={isModalOpen}
    //   onRequestClose={() => setIsModalOpen(false)}
    //   ariaHideApp={false}
    //   style={customStyle}
    // >
    <>
      <Formik initialValues={{}} onSubmit={handleSubmit}>
        {({ errors }) => (
          <Form>
            {/* Header */}
            <div className="flex justify-between items-center border-b pb-2 mb-4">
              <h2 className="text-lg font-semibold text-gray-900">
                Job Card Production Rejection Entry
              </h2>
              <div className="flex gap-2">
                <Button
                  type="submit"
                  className="cursor-pointer font-small mb-1.5 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px] active:scale-90 transition-transform duration-200"
                  shape="round"
                  color="blue_A700"
                  size="base"
                  variant="fill"
                >
                  Save
                </Button>
                {/* <Button
                  type="button"
                  className="cursor-pointer font-small mb-1.5 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px]"
                  shape="round"
                  color="white"
                  size="base"
                  variant="fill"
                  onClick={() => {
                    setIsModalOpen(false);
                    navigate(`/JobCardProductionRejectionDetailList`);
                  }}
                >
                  ╳
                </Button> */}
              </div>
            </div>

            {/* Work Order and Type */}
            <div className="flex flex-row justify-evenly mb-4">
              {/* Work Order Type */}
              <div className="flex flex-col w-60">
                <label className="font-medium mb-1 text-sm">
                  Select WorkOrder Type:
                </label>
                <Select
                  value={{
                    value: isForJobWork,
                    label: isForJobWork ? "Job Work" : "Non Job Work",
                  }}
                  onChange={(selected) => {
                    setIsForJobWork(
                      selected.value === true || selected.value === "true"
                    );
                    setSelectedWorkOrder(null);
                    setJobCardPendingList([]);
                    setSelectedItems([]);
                  }}
                  options={[
                    { value: true, label: "Job Work" },
                    { value: false, label: "Non Job Work" },
                  ]}
                  className="text-xs"
                />
              </div>

              {/* Work Order Selection */}
              <div className="flex flex-col w-60">
                <label className="font-medium mb-1 text-sm">
                  Select Work Order:
                </label>
                <Select
                  value={
                    selectedWorkOrder
                      ? {
                          value: selectedWorkOrder,
                          label:
                            workOrder.find(
                              (wo) => wo.work_order_id === selectedWorkOrder
                            )?.work_order_code || "",
                        }
                      : null
                  }
                  onChange={(selected) => {
                    const id = parseInt(selected.value);
                    setSelectedWorkOrder(id);
                    pendingJobWorkListGet(id);
                  }}
                  options={workOrder.map((wo) => ({
                    value: wo.work_order_id,
                    label: wo.work_order_code,
                  }))}
                  placeholder="-- Select --"
                  className="text-xs"
                />
              </div>

              {/* ✅ Return Warehouse (only for Job Work) */}
              {isForJobWork && (
                <div className="flex flex-col w-60">
                  <label className="font-medium mb-1 text-sm">
                    Return Warehouse:
                  </label>
                  <Select
                    value={
                      selectedReturnWarehouse
                        ? {
                            value: selectedReturnWarehouse,
                            label:
                              warehouses.find(
                                (wh) => wh.id === selectedReturnWarehouse
                              )?.warehouse_name || "",
                          }
                        : null
                    }
                    onChange={(selected) =>
                      setSelectedReturnWarehouse(selected.value)
                    }
                    options={warehouses.map((wh) => ({
                      value: wh.id,
                      label: wh.warehouse_name,
                    }))}
                    placeholder="-- Select Return Warehouse --"
                    className="text-xs"
                  />
                </div>
              )}

              {/* Rework Warehouse */}
              <div className="flex flex-col w-60">
                <label className=" mb-1 text-sm">Rework Warehouse:</label>
                <Select
                  value={
                    selectedReworkWarehouse
                      ? {
                          value: selectedReworkWarehouse,
                          label:
                            warehouses.find(
                              (wh) => wh.id === selectedReworkWarehouse
                            )?.warehouse_name || "",
                        }
                      : null
                  }
                  onChange={(selected) =>
                    setSelectedReworkWarehouse(selected.value)
                  }
                  options={warehouses.map((wh) => ({
                    value: wh.id,
                    label: wh.warehouse_name,
                  }))}
                  placeholder="-- Select Rework Warehouse --"
                  className="text-xs"
                />
              </div>
            </div>

            {/* Table */}
            {jobCardPendingList.length > 0 && (
              <table className="w-full border-collapse border text-sm">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border p-2 text-sm ">
                      <input
                        type="checkbox"
                        checked={
                          selectedItems.length === jobCardPendingList.length
                        }
                        onChange={toggleSelectAll}
                        className="rounded-sm"
                      />
                    </th>
                    <th className="border p-2 text-sm">Item Name</th>
                    <th className="border p-2 text-sm">Rejected Qty</th>
                    <th className="border p-2 text-sm">Remaining</th>
                    {isForJobWork && (
                      <th className="border p-2 text-sm">Return</th>
                    )}
                    <th className="border p-2 text-sm">Rework</th>
                    <th className="border p-2">Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {jobCardPendingList.map((item) => {
                    const id = item.job_card_production_id;
                    const checked = selectedItems.includes(id);
                    return (
                      <tr key={id}>
                        <td className="border text-center px-1 text-xs">
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={() => toggleItemSelection(id)}
                            className="rounded-sm"
                          />
                        </td>
                        <td className="border px-1 text-xs">
                          {item.item_name}
                        </td>
                        <td className="border text-center px-1 text-xs">
                          {item.quantity_rejected_for_quality_check}
                        </td>
                        <td className="border text-center px-1 text-xs">
                          {item.remaining_quantity_to_insert}
                        </td>

                        {/* ✅ Return (only for Job Work) */}
                        {isForJobWork && (
                          <td className="border p-2 text-center px-1 text-xs">
                            <Field
                              type="number"
                              name={`${id}.returnQty`}
                              disabled={!checked}
                              min="0"
                              className="border rounded p-1 w-16 text-center disabled:bg-gray-100 h-7"
                            />
                          </td>
                        )}

                        {/* Always show Rework */}
                        <td className="border text-center px-1 text-xs">
                          <Field
                            type="number"
                            name={`${id}.reworkQty`}
                            disabled={!checked}
                            min="0"
                            className="border rounded p-1 w-16 h-7 text-center disabled:bg-gray-100"
                          />
                        </td>

                        <td className="border px-1 text-xs text-center align-middle">
                          <div className="flex justify-center items-center">
                            <Field
                              type="text"
                              name={`${id}.remarks`}
                              disabled={!checked}
                              placeholder="Remarks"
                              className="border text-xs rounded p-1 w-36 h-7 text-center disabled:bg-gray-100"
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </Form>
        )}
      </Formik>

      <ToastContainer />
    </>
    // </Modal>
  );
};

export default JobCardProductionRejectionDetailListAdd;
